<template>
  <div>
  
    <div class="container-fluid">
      <div class="row full-height">
       
       <Onboarding :leadType="'Retailer'" :leadTypePlural="'Retailer'" :userGroup="'retailers'"></Onboarding>

      </div>
    </div>
  </div>
</template>

<script>
  // Imports
  import Onboarding from '../../../components/Onboarding/Onboarding.vue';
  //
  export default{
    name: 'retailer-onboarding',

    components: {
     Onboarding
    },

    props:[

    ],

    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  
</style>
